import { Application, defaultSchema } from '@hotwired/stimulus'

const schema = {
  ...defaultSchema,
  keyMappings: { ...defaultSchema.keyMappings, f2: 'F2' },
}

const application = Application.start(document.documentElement, schema)

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
